<template>
    <b-modal id="modal-manifest-preview" centered no-close-on-backdrop no-close-on-esc size="lg"
        :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
        :header-class="'align-items-center'" scrollable>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('previewHazmat.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="d-block text-center">
            <b-row>
                <b-col sm="12">
                    <div class="position-relative" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                        <iframe class="w-100 vh-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                        <div v-else>
                            <div id="panzoom-element" ref="panzoomElement">
                                <img :src="media" class="w-100 h-100 img-section" />
                            </div>
                            <div class="d-flex align-items-center justify-content-center zoom-section">
                                <b-icon @click="zoom(1)" icon="zoom-in" style="fill:white; cursor: pointer;"></b-icon>
                                <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out"
                                    style="fill:white;cursor: pointer;"></b-icon>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
           <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mt-4">
          <b-button class="mx-0 h-40px w-100px m-0" @click="$bvModal.hide('modal-manifest-preview'); panzoom = null; $emit('closePreview')"
            variant="secondary"
            >{{ $t('previewHazmat.close') }}</b-button>
        </div>
      </template>
    </b-modal>
</template>
<script>
import Panzoom from '@panzoom/panzoom'
export default {
    name: "PreviewHazmat",
    props: ['media'],
    data() {
        return {
            panzoom: null
        };
    },
    computed: {
        mediaType() {
            if (this.media) {
                if (this.media.includes('.pdf')) return 'pdf'
                else return 'image'
            }
            return null;
        }
    },
    methods: {
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        }
    }

}
</script>
<style scoped>
.overflow-preview-auto {
    overflow: auto !important;
    padding-bottom: 1rem !important;
}

.img-section {
    object-fit: contain;
    max-width: -webkit-fill-available;
    max-height: -webkit-fill-available;
    width: auto;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    object-position: top;
}

</style>